import { useCallback, useEffect, useState } from "react";
import useLiveApi from "./use-live-api";
import { VehicleAccess } from "../interfaces";

interface VehiclesAccessApi {
  data: VehicleAccess[];
  loading: boolean;
  error: boolean;
}

const fetchItems = async (
  apiGatewayFetch: (
    url: string,
    method: string,
    body?: string
  ) => Promise<Response>,
  accountId: string,
  registration?: string,
  paginationToken?: string
) => {
  let url = `/account/${accountId}/vehicle-access`;
  if (paginationToken) url += `?token=${paginationToken}`;
  const response = await apiGatewayFetch(url, "get");
  if (response.status !== 200) {
    throw new Error(response.status.toString());
  }
  return await response.json();
};

export const useVehiclesAccessApi = (accountId: string): VehiclesAccessApi => {
  const { apiGatewayFetch } = useLiveApi();
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const [data, setData] = useState<VehicleAccess[]>([]);

  const loadPage = useCallback(
    async (paginationToken?: string) => {
      setLoading(true);
      try {
        const data = await fetchItems(
          apiGatewayFetch,
          accountId,
          paginationToken
        );
        setData(data as VehicleAccess[]);
      } catch (e) {
        setError(e.message || "An error occurred");
      } finally {
        setLoading(false);
      }
    },
    [apiGatewayFetch, accountId]
  );

  useEffect(() => {
    loadPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- We only want to run this once
  }, [accountId]);

  return { data, loading, error };
};
